import React, { useState } from "react";
import { Flex, Box } from "rebass";
import { has, get, union, uniqBy, filter } from "lodash";
import Paper from "@material-ui/core/Paper";
import {
  DateInput,
  FormDataConsumer,
  useTranslate,
  useNotify,
  required,
} from "react-admin";
import { formatDate } from "../../utils";
import { getPromotion } from "../../restClient";
import ProductOrderItems from "./ProductOrderItems";
import { RaTextArea } from "../../components";

const FormFields = (props) => {
  const translate = useTranslate();
  const notify = useNotify();
  const [value, setValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const getPromotionById = (id) => {
    if (id) {
      getPromotion(id)
        .then((response) => response.json())
        .then((data) => {
          // console.log(data)
          if (data && data !== null) {
            props.updateField("promotions", data);
          }
        })
        .catch((e) => {});
    }
  };
  const onAddOrderItem = (data) => {
    const { product, promotions, qty } = data;
    if (has(product, "id") && qty && qty > 0) {
      const orderItems = get(data, "items", []);
      const newPromotions = promotions && promotions !== null ? promotions : {};
      const newItem = {
        result: {
          product_id: product.id,
          qty: qty,
          price: product.price,
          subtotal: qty * product.price,
          promotions: newPromotions, //isArray(newPromotions) ? newPromotions : [promotions],
        },
        product: product,
        product_id: product.id,
      };
      const result = union([newItem], orderItems);
      // console.log(result);
      props.updateField("items", uniqBy(result, "product_id"));
      props.updateField("product", undefined);
      props.updateField("promotions", undefined);
      props.updateField("qty", undefined);
      setValue("");
      setSuggestions([]);
    } else {
      notify("resources.orders.messages.product_qty", "warning");
    }
  };
  const onSuggestionsClearRequested = () => {
    setSuggestions([]);
  };

  const onRemoveItem = (item, orderItems) => {
    const newData = filter(orderItems, function (o) {
      return o.product_id !== item.product_id;
    });
    props.updateField("items", newData);
  };
  const onEditItem = (item) => {
    // console.log(item)
    props.updateField("product", item.product);
    props.updateField("promotions", item.result.promotions);
    props.updateField("qty", item.result.qty);
    setValue(item.product.packaging);
  };
  return (
    <Flex>
      <FormDataConsumer>
        {({ formData }) => (
          <Flex width={[1]} flexDirection={"column"}>
            <Box width={[1]} pb={[3]}>
              <Paper elevation={3} style={{ minHeight: 100 }}>
                <Box width={[1]} p={[3]} pb={[1]}>
                  <DateInput
                    source={"delivery_date"}
                    label={"resources.orders.fields.delivery_date"}
                    parse={formatDate}
                    validate={[required()]}
                  />
                </Box>
              </Paper>
            </Box>
            <ProductOrderItems
              translate={translate}
              getPromotionById={getPromotionById}
              onSuggestionsClearRequested={onSuggestionsClearRequested}
              value={value}
              setSuggestions={setSuggestions}
              suggestions={suggestions}
              setValue={setValue}
              formData={formData}
              onAddOrderItem={onAddOrderItem}
              onRemoveItem={onRemoveItem}
              onEditItem={onEditItem}
              {...props}
            />
            <Box width={[1]} py={[1]}>
              <Paper elevation={3}>
                <Box width={[1]} p={[3]}>
                  <RaTextArea
                    source='remarks'
                    label={"resources.po.fields.remarks"}
                    rows='5'
                    fullWidth
                    multiline
                    InputLabelProps={{
                      shrink: true,
                      disableAnimation: true,
                    }}
                    style={{ transform: "none" }}
                  />
                </Box>
              </Paper>
            </Box>
          </Flex>
        )}
      </FormDataConsumer>
    </Flex>
  );
};

export default FormFields;
